// extracted by mini-css-extract-plugin
export var activityContainer = "_ih-0";
export var typingIndicatorContainer = "_ih-1";
export var typingIndicatorDot = "_ih-2";
export var wave = "_ih-3";